import { HsaEligibility } from "@redotech/redo-conversion-hsa-common/hsa-eligibility";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useState } from "react";
import { HsaSubscriptionSignals } from "./hsa-learn-more-content";
import { HsaLearnMoreModal } from "./hsa-learn-more-modal";
import * as css from "./hsa-pdp-badge.module.css";

const CHECK_ICON = "https://assets.getredo.com/shop-success-check.svg";

const BADGE_TEXT: Record<
  HsaEligibility.ELIGIBLE | HsaEligibility.ELIGIBLE_WITH_LMN,
  string
> = {
  [HsaEligibility.ELIGIBLE]: "HSA/FSA accepted.",
  [HsaEligibility.ELIGIBLE_WITH_LMN]:
    "HSA/FSA eligible for qualified customers.",
};

export const HsaPdpBadge = memo(function HsaPdpBadge({
  eligibility,
  subscriptionSignals,
  onLearnMore,
}: {
  eligibility: HsaEligibility;
  subscriptionSignals: HsaSubscriptionSignals;
  /** Fired when the shopper opens the walkthrough; the badge itself writes nothing. */
  onLearnMore: () => void;
}) {
  const [modalOpen, setModalOpen] = useState(false);

  if (eligibility === HsaEligibility.NOT_ELIGIBLE) {
    return null;
  }

  return (
    <>
      <Flex align="flex-start" dir="row" gap="sm" lineHeight="1">
        <img alt="" className={css.checkIcon} src={CHECK_ICON} />
        <Flex dir="column">
          <Flex align="flex-start" dir="row" gap="sm" wrap="wrap">
            <span className={css.text}>{BADGE_TEXT[eligibility]}</span>
            <button
              className={css.learnMore}
              onClick={() => {
                onLearnMore();
                setModalOpen(true);
              }}
              type="button"
            >
              Learn more
            </button>
          </Flex>
        </Flex>
      </Flex>
      <HsaLearnMoreModal
        onClose={() => setModalOpen(false)}
        open={modalOpen}
        requiresLmn={eligibility === HsaEligibility.ELIGIBLE_WITH_LMN}
        subscriptionSignals={subscriptionSignals}
      />
    </>
  );
});
